import { createEvent, createStore, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import {
  InternalTransfer,
  InternalTransferApproveRequest,
  InternalTransferEdit,
  InternalTransferStatus,
  InternalTransfersRequest,
  InternalTransfersResponse,
  PurseBalance,
} from './types'

const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'client') {
        return [`${item[0]}.email`, item[1]?.toLowerCase()]
      } else if (item[0] === 'updatedAt' || item[0] === 'createdAt') {
        const value =
          Array.isArray(item[1]) &&
          item[1].map((date) =>
            date ? changedDateFormat(date?.$d) : `${date}`,
          )
        return [item[0], value]
      } else if (item[0] === 'transferId') {
        return ['id', item[1]?.toLowerCase()]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}
export const internalTransfersListMounted =
  createEvent<InternalTransfersRequest>()

export const getInternalTransfers = fx<
  InternalTransfersRequest,
  InternalTransfersResponse
>({
  method: 'GET',
  url: `/internal_transfer`,
})

export const $internalTransfers = restore<InternalTransfer[]>(
  getInternalTransfers.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfInternalTransfers = restore(
  getInternalTransfers.doneData.map((a) => a.body.total),
  0,
)

// ── Status change (moved from edit model) ──
export const submitStatus = createEvent<InternalTransferStatus>()
export const internalTransferMounted = createEvent()

export const updateStatusInternalTransfer = fx<
  InternalTransferApproveRequest,
  InternalTransferEdit
>({
  method: 'PUT',
  url: `/internal_transfer/`,
})

sample({
  clock: submitStatus,
  fn: ({ transferId, status }) => ({
    body: { status },
    url: `/internal_transfer/${transferId}`,
  }),
  target: updateStatusInternalTransfer,
})

// ── Purse balances for split-view detail panel ──
export const loadPurses = createEvent<InternalTransfer>()
export const setSourcePurse = createEvent<PurseBalance>()
export const setDestinationPurse = createEvent<PurseBalance>()
export const resetPurses = createEvent()

export const getSourcePurse = fx<void, PurseBalance>({
  method: 'GET',
  url: '/account/',
})

export const getDestinationPurse = fx<void, PurseBalance>({
  method: 'GET',
  url: '/account/',
})

export const $sourcePurse = createStore<PurseBalance | null>(null)
  .on(setSourcePurse, (_, p) => p)
  .reset(resetPurses)
export const $destinationPurse = createStore<PurseBalance | null>(null)
  .on(setDestinationPurse, (_, p) => p)
  .reset(resetPurses)

sample({
  clock: loadPurses,
  fn: (item) => ({
    url: item.sourceType === 'wallet' ? `/wallet/${item.sourceId}` : `/account/${item.sourceId}`,
  }),
  target: getSourcePurse,
})

sample({
  clock: loadPurses,
  fn: (item) => ({
    url: item.destinationType === 'wallet' ? `/wallet/${item.destinationId}` : `/account/${item.destinationId}`,
  }),
  target: getDestinationPurse,
})

sample({
  clock: getSourcePurse.doneData,
  fn: (doneData) => doneData.body,
  target: setSourcePurse,
})

sample({
  clock: getDestinationPurse.doneData,
  fn: (doneData) => doneData.body,
  target: setDestinationPurse,
})

sample({
  // @ts-ignore
  clock: internalTransfersListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    if (orderBy == 'transferId') {
      orderBy = 'id'
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'status'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    // @ts-ignore
    query['populate'] = JSON.stringify(['Client.wallets', 'Client.accounts'])

    return {
      query,
    }
  },
  target: getInternalTransfers,
})
